import { SelectOption } from 'client/ui/form/input/SelectInput';
import { EuCountryCodeList } from './EuCountryCodeList';
import { getNames as getCountryName, registerLocale } from 'i18n-iso-countries';
import { useTranslation } from 'react-i18next';

// Libreria, lingue e paesi disponibili: https://www.npmjs.com/package/i18n-iso-countries

// Registro le lingue italiano e inglese
registerLocale(require('i18n-iso-countries/langs/en.json'));
registerLocale(require('i18n-iso-countries/langs/it.json'));

/**
 * Hook che genera la lista dei paesi extra-europei nel format <codice> - <nome_paese>.
 * Sfrutta la libreria i18-iso-countries per tradurre i nomi dei paesi.
 */
export function useExtraEuCountryCode() {
  const { t, i18n } = useTranslation();

  const countries = getCountryName(i18n.language, { select: 'official' });

  const options = Object.keys(countries)
    .filter(code => !EuCountryCodeList.some(eu => eu == code))
    // Rimuovo l'Italia dalla lista
    .filter(code => code !== 'IT')
    .map(
      code =>
        ({
          value: code,
          label: `${code} - ${
            countries[code] ??
            t('user.registration.country.unkown', 'Sconosciuto')
          }`
        } as SelectOption)
    );

  return { options };
}
